import Accounting from '@accounting/accounting';
import InvoiceList from '../components/invoices/invoice-list';
import InvoiceReminderList from '../components/invoice-reminder/invoice-reminder-list';
import Reports from '../components/reports/reports';
import { getDetailsTabRouteObjects } from '../../../utility/route';
import { invoiceListLDTRoutes, invoiceReminderListLDTRoutes as invoiceReminderListLDTRoutes } from './routes';
//import BookingReports from '../components/reports/booking-reports';
import BookingReports from '../components/reports/accounting-booking-reports.vue';
//import InvoiceReports from '../components/reports/invoice-reports';
import InvoiceReports from '../components/reports/accounting-invoice-reports.vue';
import { costListLDTRoutes } from './routes';
import AccountingPlugins from '../components/plugins/plugins';
import CostList from '../components/costs/cost-list';

export default [{
  path: '/main/accounting',
  name: 'accounting',
  component: Accounting,
  redirect: 'main/accounting/invoices',
  children: [
    ...getDetailsTabRouteObjects(invoiceListLDTRoutes, InvoiceList),
    ...getDetailsTabRouteObjects(invoiceReminderListLDTRoutes, InvoiceReminderList),
    ...getDetailsTabRouteObjects(costListLDTRoutes, CostList),
    {
      name: 'accounting_reports',
      path: 'reports',
      redirect: 'reports/invoice',
      component: Reports,
      children: [
        {
          name: 'accounting_reports_invoice',
          path: 'invoice',
          component: InvoiceReports
        },
        {
          name: 'accounting_reports_booking',
          path: 'booking',
          component: BookingReports
        }
      ]
    },
    {
      name: 'accounting_plugins',
      path: "plugins",
      component: AccountingPlugins
    },
  ],
},];